import { companyRoles } from '@/constants/permissions'
import { useApp } from '@/use/app'

const PLAIN_URLS: string[] = [
  '/company/locations/mapview',
  '/company/dispatch',
  '/company/work_order_services',
  '/company/outbound/report_summary',
  '/company/inbound/report_summary',
  '/company/outbound/agreement_contracts',
  '/company/inbound/agreement_contracts',
  '/company/trades',
  '/company/company_materials',
  '/company/item_types',
  '/company/ledger_accounts',
  '/users/settings',
  '/company/labor_rates',
  '/company/service_rates',
  '/company/task_rates',
  '/company/equipment_task_rates',
  '/company/event_rates',
  '/company/settings/',
  '/company/my_workorders/work_orders',
  '/company/my_workorders/work_orders',
  '/company/outbound/past/agreement_contracts',
  '/company/outbound/current/agreement_contracts',
  '/company/agreement_contracts',
  '/company/current/agreement_contracts',
  '/company/past/agreement_contracts',
  '/company/service_requests/site_selections',
  '/company/reports/location_reports'
]

const PARAMETRIZED_URLS: Record<companyRoles, string[]> = {
  broker: [
    '/company/locations/:id/agreement_contracts',
    '/company/wizard/locations/:id/service_rate/edit',
    '/company/wizard/clients/:id/service_rates/edit',
    '/company/vendors/:id/agreement_contracts',
    '/company/wizard/contractors/:id/service_rates/edit',
    '/company/clients/:id/agreement_contracts'
  ],
  vendor: [
    '/company/locations/:id/agreement_contracts',
    '/company/clients/:id/agreement_contracts'
  ],
  client: [
    '/company/locations/:location_id/new',
    '/company/locations/:location_id/trade_service_selection/:id/edit',
    '/company/locations/:location_id/problem_description/:id/edit',
    '/company/locations/:location_id/photos/:id/edit',
    '/company/locations/:location_id/confirmation/:id/edit',
    '/company/locations/:location_id/agreement_contracts'
  ]
}
const paramRegex = /:([A-Z_]\w*)\b/gi

export function railsExceptionUrls (): string[] {
  const { companyType } = useApp()
  if (!companyType.value) { return PLAIN_URLS }

  const parametrizedUrls = PARAMETRIZED_URLS[companyType.value] ?? []
  return [...PLAIN_URLS, ...parametrizedUrls]
}

export function isAllowedRailsUrl (route: string): boolean {
  const allowedUrls = railsExceptionUrls()
  if (!allowedUrls.length) { return false }

  return allowedUrls.some((url: string) => {
    if (paramRegex.test(url)) {
      const pattern = url.replace(paramRegex, '\\d+')
      const regex = new RegExp(`^${pattern}(?:$|/)`)
      return regex.test(route)
    } else {
      return route.startsWith(url)
    }
  })
}
